/**
 * FilterToggle Component
 *
 * Button to toggle filters panel visibility with active filters indicator
 */

import { memo } from 'react';
import { FilterIconButton } from '../../FilterIconButton';
import type { FilterToggleProps } from '../SearchAndFilters.types';

export const FilterToggle = memo(function FilterToggle({
  expanded,
  hasActiveFilters,
  onClick,
  tooltip = 'Filters',
  'aria-label': ariaLabel = 'Toggle filters',
  size = 'input',
}: FilterToggleProps) {
  return (
    <FilterIconButton
      opened={expanded}
      hasActiveFilters={hasActiveFilters}
      onClick={onClick}
      tooltip={tooltip}
      aria-label={ariaLabel}
      size={size}
    />
  );
});
